module.exports = __webpack_public_path__ + "img/OccManageSys.dc7e8a64.jpg";